module.exports = __webpack_public_path__ + "img/90.cc4f5af8.png";